// src/components/ProtectedRoute.jsx
import React, { useEffect } from 'react';
import { useSelector, useDispatch } from 'react-redux';
import { Navigate, useLocation } from 'react-router-dom';
import { checkTokenExpiry } from './redux/Slices/authSlice';

const ProtectedRoute = ({ children }) => {
  const dispatch = useDispatch();
  const location = useLocation();
  const { isAuthenticated, token, error } = useSelector((state) => state.auth);

  useEffect(() => {
    dispatch(checkTokenExpiry());
  }, [dispatch, location.pathname]);

  const storedToken = localStorage.getItem('token');
  const storedExpiry = localStorage.getItem('tokenExpiry');
  
  if (storedToken && storedExpiry) {
    const isExpired = Date.now() >= parseInt(storedExpiry);
    if (isExpired) {
      return <Navigate to="/" state={{ from: location }} replace />;
    }
  }

  if (!isAuthenticated && !storedToken) {
    return <Navigate to="/" state={{ from: location }} replace />;
  }

  if (error && error.includes('expired')) {
    return <Navigate to="/" state={{ from: location }} replace />;
  }

  return children;
};

export default ProtectedRoute;